import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { InsightService } from '../partner-portal/services/insight.service';
import { lastValueFrom } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { NotificationService } from '../core/services/notification.service';
import CryptoJS from 'crypto-js';
import { ActivatedRoute } from '@angular/router';
import { PolicyConstant } from '../partner-portal/Model/policyConstant';
import { EndorsementService } from '../partner-portal/services/endorsement.service';
export interface docDescription {
  fileName: string;
  docName: string;
  link: string;
  delete: string;
}
@Component({
    selector: 'app-otp-verification-cancellation',
    templateUrl: './otp-verification-cancellation.component.html',
    styleUrls: ['./otp-verification-cancellation.component.css'],
    standalone: false
})

export class OtpVerificationCancellationComponent implements OnInit {

  otpForm !: FormGroup;
  dataSource = new MatTableDataSource<any>([]);
  displayedAllColumns: string[];
  displayedColumns: string[];
  DocDescColums: string[] = ['fileName', 'docName', 'link', 'delete'];
  policyNumber: string;
  cancellationNumber: string = '';
  productId: string = '';
  productName: string = '';
  customerMobileNumber: string = '';
  cancelPolicyNumber: string = '';
  user: any[] = [];
  status: any;
  xmlData: string;
  isCustomercancellationVerification: boolean = false;
  constructor(private insightService: InsightService, private fb: FormBuilder, private notify: NotificationService, private route: ActivatedRoute, private endorsementService: EndorsementService) { }

  proposalColumnHeader = {
    documentName: 'File Name',
    documentCategory: 'Category Name'
  };

  
  get getOtpFormControls() {
    return this.otpForm.controls;
  }

  ngOnInit(): void {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.minLength(6)]]
    });
 
    this.route.queryParams.subscribe(params => {
      if ('policyNo' in params) {
        this.policyNumber = params.policyNo;
      }
    })
    const BASE_64_STR = this.policyNumber?.substring(5) || '';
    let DECODED_STR = CryptoJS.enc.Base64.parse(BASE_64_STR);
    let policyNo = CryptoJS.enc.Utf8.stringify(DECODED_STR) || '';
    
    policyNo = policyNo.replace(/\[/g,'').replace(/\]/g,'').trim();
    this.policyNumber = policyNo || this.policyNumber;

    this.displayedColumns = Object.keys(this.proposalColumnHeader);
    this.displayedAllColumns = [...this.displayedColumns, 'link', 'delete'];
 
    this.getCancellationData(this.policyNumber);
  }

  async getCancellationData(policyNumber: any) {
    const res = await lastValueFrom(this.insightService?.getCancellationCustomerData(policyNumber));
    if (res?.result) {
      this.user = res?.result;
      this.cancellationNumber = res?.result?.cancellationRequestNumber;
      this.productId = res?.result?.productCode;
      this.cancelPolicyNumber = res?.result?.policyNumber;
      this.productName = res?.result?.productName;
      this.customerMobileNumber = res?.result?.customerMobileNumber;
      this.cancellationDocumentData(this.cancellationNumber);
    }
  }

  cancellationDocumentData(cancellationRequestNumber: any) {
    this.insightService
      ?.getCancellationDocumentData(cancellationRequestNumber)
      .subscribe((res: any) => {
        this.dataSource.data = res?.result;
      })
  }

   downloadEFile(fileName: any, documentType: any): void {
      this.xmlData = `<FileUploadData><EntityInformation><MetadataProperties><MetadataProperty Name="Documentfile_no" Value="" /><MetadataProperty Name="documentset_no" Value="" /><MetadataProperty Name="ClaimNumber" Value=""/><MetadataProperty Name="CaseId" Value="" /><MetadataProperty Name="PolicyNumber" Value="" /><MetadataProperty Name="EndorsementNumber" Value="" /><MetadataProperty Name="DocumentGroup" Value="" /><MetadataProperty Name="DocumentType" Value="" /><MetadataProperty Name="DocumentTitle" Value="" /></MetadataProperties></EntityInformation></FileUploadData>`;
  
      const xmlDoc = new DOMParser().parseFromString(this.xmlData, 'text/xml');
      const CaseIdElement = xmlDoc.querySelector('MetadataProperty[Name="PolicyNumber"]');
      CaseIdElement.setAttribute('Value', "");
      const endorsementNumberElement = xmlDoc.querySelector('MetadataProperty[Name="EndorsementNumber"]');
      endorsementNumberElement.setAttribute('Value', this.cancellationNumber);
      const DocumentGroupElement = xmlDoc.querySelector('MetadataProperty[Name="DocumentGroup"]');
      DocumentGroupElement.setAttribute('Value', 'Policy Documentation');
      const documentTypeElement = xmlDoc.querySelector('MetadataProperty[Name="DocumentType"]');
      documentTypeElement.setAttribute('Value', PolicyConstant.CancellationEndorsement + ' Document');
      const DocumentTitleElement = xmlDoc.querySelector('MetadataProperty[Name="DocumentTitle"]');
      DocumentTitleElement.setAttribute('Value', fileName);
      this.xmlData = new XMLSerializer().serializeToString(xmlDoc);
      this.endorsementService.downloadEFile(this.xmlData).subscribe((res: any) => {
        const downloadURL = window.URL.createObjectURL(res);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = fileName;
        link.click();
      });
    }

  allowOnlyNumeric(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onCopyPasteNumber(event: ClipboardEvent, maxLength: Number): void {
    event.preventDefault();
      let pasteText = event.clipboardData?.getData('Text') || '';
      console.log("text is :", pasteText);
      let inputElement = event.target as HTMLInputElement;
      const removeSpecialchars = pasteText.replace(/[^0-9]/g, '');
      let pastText = removeSpecialchars;
  
      if (pastText) {
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        input.setRangeText(pastText, start, end, 'start');
      }
  }

  submitCancellation() {

      const enteredOtp = this.getOtpFormControls.otp.value;
      let payload = {
        "mobileNumber": this.customerMobileNumber,
        "proposalNumber": this.cancellationNumber,
        "otp": enteredOtp,
        "modeofOperation": "otp-MotorCancellation",
        "endorsementNumber": this.cancellationNumber,
        "productId": this.productId,
        "smsIndicator": true,
        "cancellationRequestNumber": this.cancelPolicyNumber,
        "customerId": "",
        "emailId": "",
        "productName": this.productName
      }
      this.insightService.ValidateCancellationOtp(payload).subscribe((res: any) => {
        if (res && res.status == 200) {
          this.notify.showSuccess("Otp Successfully Verified ", '')
        }
        else {
          this.notify.showError("Invalid Otp ", '')
        }
      })
    }

}
